import { FC } from "react";

export const Search: FC<{
  className?: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  onClear?: () => void;
}> = ({ className, onChange, onClear, placeholder, value }) => {
  return (
    <div className={`relative h-14 mb-4 select-none ${className}`}>
      <input
        className="w-full h-14 py-4 pr-4 pl-9 focus:outline-none border-b border-gray-100 focus:border-blue-700 appearance-none placeholder-gray-500"
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Escape") {
            onClear && onClear();
          }
        }}
        placeholder={placeholder}
        type="search"
        value={value}
      />

      <div className="absolute left-0 top-0 w-7 h-14 flex items-center justify-center"></div>
    </div>
  );
};
